/**
 * Created by chenguangpeng on 2018/10/09 14:30
 */

// ===================================
// ===========  天为食  ===============
// =========== ------- ===============
// ----------- 天为食api---------------
// ===================================
import request from '../ajax';

export function fetchRecommendations(params) {
    return request.post({
        // url: 'http://192.168.239.53:7300/mock/5b3337cb878dfb25206c13f8/utopa/app.do/recommendations',
        reqMethod: 'popularize.recommendation.selectRecommendations',
        params: params
    })
}
export function fetchAdvertisementConfig(params) {
    return request.post({
        // url: 'http://192.168.239.53:7300/mock/5b3337cb878dfb25206c13f8/utopa/twsad',
        reqMethod: 'base.advertisement.getAdvertisementConfig',
        params: params
    })
}
export function fetchSelectShops(params) {
    return request.post({
        // url: 'http://192.168.239.53:7300/mock/5b3337cb878dfb25206c13f8/utopa/selectshops',
        reqMethod: 'eshop.shop.selectShopFoodsByColumnNo',
        params: params
    })
}

export function fetchGoodsQueryList(params) {
    return request.post({
        // url: 'http://192.168.239.53:7300/mock/5b3337cb878dfb25206c13f8/utopa/goodscoupon',
        reqMethod: 'eshop.goodsSaleWay.getGoodsList',
        params: params
    })
}